import { PlayerProjectionFragment } from '@/api/events/query.generated';
import { checkIfDiscountedProjection } from '@/feature/lobby/utils/lineupsUtils';

const sortSpecialPick = (projection: PlayerProjectionFragment) => {
    return !checkIfDiscountedProjection(projection.type) ? 1 : 0;
};

const sortByProjectionType = (projection1: PlayerProjectionFragment, projection2: PlayerProjectionFragment) => {
    return sortSpecialPick(projection1) - sortSpecialPick(projection2);
};

const sortByOrder = (projection1: PlayerProjectionFragment, projection2: PlayerProjectionFragment) => {
    return projection1.order - projection2.order;
};

export const sortProjections = (projection1: PlayerProjectionFragment, projection2: PlayerProjectionFragment) => {
    return sortByProjectionType(projection1, projection2) || sortByOrder(projection1, projection2);
};

/**
 * Groups projections in an object by their type.
 * @param projections
 * @returns An object where the keys are types and the values are arrays of projections of that type.
 */
export const sortAndGroupProjectionsByType = (
    projections: PlayerProjectionFragment[],
    playerProjectionFilter?: string
): { [key: string]: PlayerProjectionFragment[] } => {
    const grouped = projections.reduce((acc: { [key: string]: PlayerProjectionFragment[] }, currentObject) => {
        const type = currentObject.key;
        if (acc[type]) {
            acc[type].push(currentObject);
        } else {
            acc[type] = [currentObject];
        }
        return acc;
    }, {});

    if (playerProjectionFilter && grouped[playerProjectionFilter]) {
        const { [playerProjectionFilter]: filteredGroup, ...rest } = grouped;
        return {
            [playerProjectionFilter]: filteredGroup,
            ...rest,
        };
    }

    return grouped;
};
